<template>
  <div class="col data-block news-block" v-if="newsPresent">
    <h1 class="title" v-if="newsTitle">
      {{ newsTitle }}
    </h1>
    <div class="wrapper" :class="newsBarClasses">
      <div title="View News">
        <span v-html="shortText"></span>
        <div v-html="expandedText" v-if="expanded"></div>
        <a href="#" class="continue-reading" v-if="!expanded && expandedText" @click.prevent="toggleExpanded">
          <span>{{ $t('Continue reading') }}</span>
        </a>
        <a href="#" class="continue-reading" v-if="expanded" @click.prevent="toggleExpanded">
          <span tabindex="-1">{{ $t('Collapse') }}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'News',
  props: ['news', 'newsTitle'],
  data() {
    return {
      expanded: false,
    };
  },
  mounted() {
    if (this.$route.path.length > 0 && /expand-news/.test(this.$route.path)) {
      this.expanded = true;
    }
  },
  computed: {
    newsPresent() {
      // There is a feed update that changed null to ---
      return typeof (this.news) !== 'undefined' && this.news !== '--';
    },
    shortText() {
      if (this.news.indexOf('...more...') < 0) { return this.news; }

      return this.news.split('...more...')[0];
    },
    expandedText() {
      return this.news.split('...more...')[1];
    },
    newsBarClasses() {
      if (this.expanded) { return 'news-expanded'; }
    },
  },
  methods: {
    toggleExpanded() {
      if (this.expandedText) {
        this.expanded = !this.expanded;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.news-block {
  flex-basis: 100% !important;
  overflow: hidden;
  width: 100%;
  @media (max-width: $tablet-landscape) {
    margin-top: 0;
    min-width: 50%;
  }
  @media (min-width: $tablet-landscape) {
    flex-basis: 50%;
  }
  .wrapper {
    margin-top: 20px;
    transition: all ease-in-out .15s;
    @media (min-width: $tablet) {
      margin-top: 0;
      max-height: 150px;
      &.news-expanded {
        max-height: 500px;
      }
    }
  }
  a.continue-reading {
    color: $dark-gray;
    display: block;
    font-family: $base-font-bold;
    font-size: 14px;
    font-weight: 600;
    line-height: 1.2;
    margin-top: 5px;
    &:hover {
      border-bottom: transparent 0px solid; // Override
      span {
        border-bottom: 1px solid $link-color;
      }
    }
  }
}
</style>

<i18n locale="fr-ca">
{
  "Continue reading": "Lire la suite",
  "Collapse": "Réduire"
}
</i18n>
